import req from '../http.js';

// 获取数据库类型列表
export const getDbType = (params) => {
  return req('get', '/console/pipeline-db-type/getDbType',
    params
  );
};

// 新增或修改物理库
export const addOrEditDb = (params) => {
  return req('post', '/console/pipeline-physical-db/addOrEdit', params);
};

// 删除物理库
export const deletePhysicalDb = (params) => {
  return req('get', '/console/pipeline-physical-db/deletePhysicalDb', {
    ...params
  });
};

// 获取物理库详情
export const getDbDetail = (params) => {
  return req('get', '/console/pipeline-physical-db/getDetail', {
    ...params
  });
};

// 获取物理库列表
export const getDbTableList = (params) => {
  return req('get', '/console/pipeline-physical-db/getList', params);
};

// 新增或修改table表
export const addOrEditTable = (params) => {
  return req('post', '/console/pipeline-physical-table/addOrEdit', params);
};

// 删除table表
export const deletePhysicalTable = (params) => {
  return req('get', '/console/pipeline-physical-table/deletePhysicalTable', {
    ...params,
  });
};

// 获取table列表 ???
export const getTableList = (params) => {
  return req('get', '/console/pipeline-physical-table/getList', {
    ...params
  });
};

// 根据物理库SchemaID获取table列表
export const getListBySchemaID = (params) => {
  return req('get', '/console/pipeline-physical-table/getListBySchemaID', {
    ...params
  });
};

// 新增或修改物理库schema
export const addOrEditSchemaID = (params) => {
  return req('post', '/console/pipeline-physical-schema/addOrEdit', params);
};
// 删除物理库schema
export const deletePhysicalSchema = (params) => {
  return req('get', '/console/pipeline-physical-schema/deletePhysicalSchema', {
    ...params
  });
};
// 获取物理库schema列表
export const getSchemaList = (params) => {
  return req('get', '/console/pipeline-physical-schema/getList', {
    ...params
  });
};
// 根据物理库ID获取Schema列表
export const getListByDataBaseId = (params) => {
  return req('get', '/console/pipeline-physical-schema/getListByDataBaseId', {
    ...params
  });
};
